import ClockIcon from 'components/ReusableComponents/Icons/Clock'
import CoinsIcon from 'components/ReusableComponents/Icons/Coins'
import GiftIcon from 'components/ReusableComponents/Icons/Gift'
import UserIcon from 'components/ReusableComponents/Icons/User'
import CalendarComplete from 'features/CustomCampaigns/EditCampaign/CalendarComplete'
import useCampaignCredits from 'hooks/useCampaignCredits'
import moment from 'moment'
import { formatPrice } from 'utils/common'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './EditCampaign.module.scss'

const CustomCampaignEstimation = ({
  deliveryStartDate,
  deliveryFinishDate,
  guestsToText,
  guestsToEmail,
  totalGuestsToReach
}) => {
  const sentTextsPerDay = 1000
  const textCostPerDay = 0.06

  const sentEmailsPerDay = 250
  const emailCostPerDay = 0.0

  const { credits } = useCampaignCredits()

  const guestsWillBeReached = deliveryFinishDate
    ? Math.min(
        moment(deliveryFinishDate).diff(deliveryStartDate, 'days') * sentTextsPerDay,
        totalGuestsToReach
      )
    : totalGuestsToReach

  const guestWillBeEmailed = deliveryFinishDate
    ? Math.min(
        moment(deliveryFinishDate).diff(deliveryStartDate, 'days') * sentEmailsPerDay,
        guestsToEmail
      )
    : guestsToEmail

  const guestsWillBeTexted = deliveryFinishDate
    ? Math.min(
        moment(deliveryFinishDate).diff(deliveryStartDate, 'days') * sentTextsPerDay,
        guestsToText
      )
    : guestsToText

  const campaignDurationInDays = Math.floor(guestsWillBeReached / sentTextsPerDay)
  // const campaignCost =
  //   (guestsWillBeReached - Math.min(guestsWillBeReached, credits)) * textCostPerDay

  const campaignCost =
    (guestsWillBeTexted - Math.min(guestsWillBeTexted, credits)) * textCostPerDay +
    guestWillBeEmailed * emailCostPerDay

  const estimatedEndDate = moment(deliveryStartDate).add(
    campaignDurationInDays + 1,
    'day'
  )

  return (
    <div className={styles.estimationHolder} id="text-blast-estimation">
      <div className={styles.estimatedEndDateHolder}>
        <CalendarComplete />
        <div className={styles.estimatedEndDateInner}>
          <p className={styles.estimatedEndDateLabel}> Estimated end date</p>
          <p className={styles.estimatedEndDateValue}>
            {estimatedEndDate.format('MMM D, YYYY')}{' '}
          </p>
        </div>
      </div>
      <div className={styles.estimationDetails}>
        <div className={styles.estimationDetailsRow}>
          <UserIcon width={20} />
          <p className={styles.estimationDetailText}>
            {formatNumberAsThousands(guestsWillBeReached)} guests will be reached
          </p>
        </div>
        {credits > 0 && (
          <div className={styles.estimationDetailsRow}>
            <GiftIcon width={20} />
            <p className={styles.estimationDetailText}>
              {Math.min(credits, guestsWillBeReached)} complimentary texts
            </p>
          </div>
        )}
        <div className={styles.estimationDetailsRow}>
          <CoinsIcon width={20} style={{ position: 'relative', left: 1 }} />
          <p className={styles.estimationDetailText}>
            {formatPrice(campaignCost)} approx. ({formatPrice(textCostPerDay)} / text)
          </p>
        </div>
        <div className={styles.estimationDetailsRow}>
          <ClockIcon width={'1.3em'} height={'1.3em'} />
          <p className={styles.estimationDetailText}>
            Text will be sent around 5pm according to guest time zone
          </p>
        </div>
      </div>
    </div>
  )
}

export default CustomCampaignEstimation
